import Aurora from "./Aurora";
function App() { return <Aurora />; }
export default App;
